import { productAction } from '../actionTypes'
import {Url} from '../../config/config'
import axios from 'axios'
import { isLoggedIn } from '../../utils'

// //------------------------------------------------ORDER-LIST-----------------------------------------------



export const orderStatusInitate = () => ({
    type: productAction.CHANGE_ORDER_STATUS_INITIATE,
  });
  
  export const orderStatusSuccess = (data) => ({
    type: productAction.CHANGE_ORDER_STATUS_SUCCESS,
    payload: data,
  });
  
  export const  orderStatusFailure = (data) => ({
    type: productAction.CHANGE_ORDER_STATUS_FAILURE,
    payload: data,
  });
  
  export function orderStatusAction(payload) {
    const token = isLoggedIn("ownerLogin");

    return (dispatch) => {
      dispatch(orderStatusInitate());
      return new Promise((resolve, reject) => {
        axios
          .post(`${Url}store/changeOrderStatus`, payload, {
            headers: { Authorization: `${token}` },
          })
          .then((response) => {
            const data = response.data;
            if (data && data.status == 200) {
              dispatch(orderStatusSuccess(data));
              resolve(data)
              //console.log(`transactionList ---  ${data}`);
            } else {
              dispatch(orderStatusFailure(data));
              reject(data)
            }
          })
          .catch((err) => {
            dispatch(orderStatusFailure(err));
            reject(err);
          });
      });
    };
  }












// export const orderListInitiate = () => ({
//   type:orderAction.ORDER_LIST_INITIATE
// })

// export const orderListSuccess = (data) => ({
//   type:orderAction.ORDER_LIST_SUCCESS,
//   payload:data
// })

// export const orderListFailure = (data) => ({
//   type:orderAction.ORDER_LIST_FAILURE,
//   payload: data
// })

export function getOrderListForSocket(payload) {
  return dispatch => {
      const token = isLoggedIn("ownerLogin");
      return new Promise((resolve, reject) =>
          axios.post(`${Url}store/orderListSocket`, payload,{
              headers: { Authorization: `${token}` }
            })
              .then(response => {
                const data = response.data
           
                  if (data.status=== 200){
                     
                  }
                  else{
                 
                  }
                  resolve(data);
              })
              .catch(err => {
                
                  reject(err);
              })
      );
  }
}

// //------------------------------------------------ORDER-DETAILS-----------------------------------------------

// export const orderDetailInitiate = () => ({
//   type:orderAction.ORDER_DETAILS_INITIATE
// })

// export const orderDetailSuccess = (data) => ({
//   type:orderAction.ORDER_DETAILS_SUCCESS,
//   payload:data
// })

// export const orderDetailFailure = (data) => ({
//   type:orderAction.ORDER_DETAILS_FAILURE,
//   payload: data
// })

// export function getOrderDetail(payload) {
//   return dispatch => {
//       const token = isLoggedIn("ownerLogin");
//      dispatch(orderDetailInitiate(payload))
//       return new Promise((resolve, reject) =>
//           axios.post(`${Url}store/orderDetails`, payload,{
//               headers: { Authorization: `${token}` }
//             })
//               .then(response => {
//                 const data = response.data
           
//                   if (data.status=== 200){
//                       dispatch(orderDetailSuccess(data))
//                   }
//                   else{
//                     dispatch(orderDetailFailure(data))
//                   }
//                   resolve(data);
//               })
//               .catch(err => {
//                   dispatch(orderDetailFailure(err))
//                   reject(err);
//               })
//       );
//   }
// }


//------------------------------------------------ORDER-Status-----------------------------------------------

// export const orderChangeStatusInitiate = () => ({
//   type:orderAction.CHANGE_ORDER_STATUS_INITIATE
// })

// export const orderChangeStatusSuccess = (data) => ({
//   type:orderAction.CHANGE_ORDER_STATUS_SUCCESS,
//   payload:data
// })

// export const orderChangeStatusFailure = (data) => ({
//   type:orderAction.CHANGE_ORDER_STATUS_FAILURE,
//   payload: data
// })

// export function getOrderChangeStatus(payload) {
//   return dispatch => {
//       const token = isLoggedIn("ownerLogin");
//      dispatch(orderChangeStatusInitiate(payload))
//       return new Promise((resolve, reject) =>
//           axios.post(`${Url}store/changeOrderStatus`, payload,{
//               headers: { Authorization: `${token}` }
//             })
//               .then(response => {
//                 const data = response.data
           
//                   if (data.status=== 200){
//                       dispatch(orderChangeStatusSuccess(data))
//                   }
//                   else{
//                     dispatch(orderChangeStatusFailure(data))
//                   }
//                   resolve(data);
//               })
//               .catch(err => {
//                   dispatch(orderChangeStatusFailure(err))
//                   reject(err);
//               })
//       );
//   }
// }

